export default "__VITE_PUBLIC_ASSET__a052463c__"